import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tiles, Container, Content, Title, i18n, tokens } from '@simplybenefits/sb-ui-library';
import Settings from './Settings';
import ChangePassword from './ChangePassword';
import Banking from './Banking/index.js';
import { initUpdateCreditCard, finalizeCreditCardUpdate, setCurrentSidebarItem } from "../../actions/user";
import * as notifier from "../../actions/notifier";

class Account extends Component {
    state = {
        settingsDialogOpen: false,
        changePasswordDialogOpen: false,
        bankingDialogOpen: false
    };

    componentDidMount() {
        this.props.dispatch(setCurrentSidebarItem('my-account'));

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const sessionID = urlParams.get('session_id'); // stripe session_id
        const state = urlParams.get('state');

        if (sessionID) {
            this.props.dispatch(finalizeCreditCardUpdate(sessionID));
            window.location.href = '/my-account?state=success';
        }

        if (state === 'success') {
            this.props.dispatch(notifier.displayMessage(i18n.t(tokens.labels.account.creditCardUpdatedSuccessfully)));

            setTimeout(() => {
                window.location.href = '/my-account';
            }, 3000);
        }
    }

    _toggleDialog = (type) => {
        this.setState({
            [`${ type }DialogOpen`]: !this.state[`${ type }DialogOpen`]
        });
    };

    render() {
        const { meta } = this.props;

        let tiles = [
            {
                title: i18n.t(tokens.titles.accountDetails),
                description: i18n.t(tokens.labels.account.accountSettingsDescription),
                onClick: () => this._toggleDialog('settings'),
                testid: 'settings-tile'
            },
            {
                title: i18n.t(tokens.titles.changePassword),
                description: i18n.t(tokens.labels.account.changePasswordDescription),
                onClick: () => this._toggleDialog('changePassword'),
                testid: 'change-password-tile'
            },
            {
                title: i18n.t(tokens.titles.bankingDetails),
                description: i18n.t(tokens.labels.account.managePaymentReimbursementDetails),
                onClick: () => this._toggleDialog('banking'),
                testid: 'banking-tile'
            },
            {
                title: i18n.t(tokens.titles.dependents),
                description: i18n.t(tokens.labels.account.manageDependents),
                link: '/my-account/dependents',
                testid: 'dependents-tile'
            },
            {
                title: i18n.t(tokens.titles.beneficiaries),
                description: i18n.t(tokens.labels.account.manageBeneficiaries),
                link: '/my-account/beneficiaries',
                testid: 'beneficiaries-tile'
            },
            {
                title: i18n.t(tokens.titles.trustee),
                description: i18n.t(tokens.labels.account.manageTrustee),
                link: '/my-account/trustee',
                testid: 'trustee-tile'
            }
        ];

        if (meta.divisionPaymentType === 'member' && meta.paymentType === 'CC') {
            tiles.splice(3, 0, {
                title: i18n.t(tokens.titles["update credit card"]),
                description: i18n.t(tokens.labels.account.updateCreditCardOnFile),
                onClick: async () => {
                    window.location.href = await this.props.dispatch(initUpdateCreditCard());
                },
                testid: 'banking-tile',
                icon: 'Banking Details'
            });
        }

        if (meta.isDependent) {
            tiles = [
                {
                    title: i18n.t(tokens.titles.changePassword),
                    description: i18n.t(tokens.labels.account.changePasswordDescription),
                    onClick: () => this._toggleDialog('changePassword'),
                    testid: 'change-password-tile'
                }
            ];
        }

        return (
            <Container>
                <Content>
                    <Title title={ i18n.t(tokens.titles["my account"]) } />
                    <Tiles tiles={tiles} />
                </Content>

                {
                    this.state.settingsDialogOpen &&
                        <Settings close={() => this._toggleDialog('settings')}/>
                }

                {
                    this.state.changePasswordDialogOpen &&
                        <ChangePassword close={() => this._toggleDialog('changePassword')}/>
                }

                {
                    this.state.bankingDialogOpen &&
                        <Banking close={() => this._toggleDialog('banking')} />
                }
                <span id="my-account" />
            </Container>
        );
    }
}

Account.propTypes = {
    meta: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    meta: state.user.meta
});

export default (connect(mapStateToProps)(Account));